<template>
	<td :class="[
			'text-no-wrap',
			'text-center',
			'caption',
			grey ? 'primary--text text--lighten-4' : ''
		]"
		style="height: 36px;"
	>
		<v-row>
			<v-col cols="6" class="py-1">
				<template v-if="editMode">
					<a-number-field-inline
						ref="percent"
						class="caption"
						v-model="percent"
						suffix="%"
						digits="0"
						@focus="$emit('focus')"
						@blur="$emit('blur')"
						@change="percentChange"
					></a-number-field-inline>
				</template>
				<template v-else>
					{{ percent }}%
				</template>
			</v-col>
			<v-col cols="6" class="py-1">
				<template v-if="editMode">
					<a-number-field-inline
						ref="sum"
						class="caption"
						v-model="sum"
						@focus="$emit('focus')"
						@blur="$emit('blur')"
						@change="sumChange"
					></a-number-field-inline>
					<!-- @focus="showSnackPrepay(i)"
					@blur="hideSnackPrepay()" -->
				</template>
				<template v-else>
					{{ sum }}
				</template>
			</v-col>
		</v-row>
	</td>
</template>

<script>
	import { toStr, toNum } from '../../../js/common'
	import aNumberFieldInline from '../../base/ANumberFieldInline.vue'

	export default {
		components: {
			aNumberFieldInline,
		},
		props: {
			prepay: [ String, Number ],
			sumGross: [String, Number],
			editMode: Boolean,
			grey: Boolean,
		},
		data: function() {
			return {
				percent: '',
				sum: ''
			}
		},
		watch: {
			sumGross(val, old) {
				// console.log('component - sumGross watcher', val)

				if (old != 0) {
					this.sum = toStr(toNum(this.percent) / 100 * toNum(val))
				}
				else {
					this.sum = val
					this.percent = toNum(val) ? 100 : 0
				}

				this.$emit('update:prepay', this.sum)
			}
		},
		created() {
			this.sumChange(this.prepay, false)
		},
		methods: {
			percentChange(val, emit) {
				if (emit === undefined) emit = true

				val = toNum(val)
				val = val < 0 ? 0 : val
				val = val > 100 ? 100 : val
				// console.log('val', val)
				this.percent = val.toFixed(0)
				this.sum = toStr(val / 100 * toNum(this.sumGross))

				if (emit) {
					this.$emit('update:prepay', this.sum)
				}
			},
			sumChange(val, emit) {
				if (emit === undefined) emit = true

				let sumGrossNum = toNum(this.sumGross)

				val = toNum(val)
				val = val < 0 ? 0 : val
				val = val > sumGrossNum ? sumGrossNum : val
				// console.log('val', val)
				this.sum = toStr(val)

				if (sumGrossNum != 0) {
					this.percent = (toNum(this.sum) / sumGrossNum * 100).toFixed(0)
				}
				else {
					this.percent = 0
				}

				if (emit) {
					this.$emit('update:prepay', this.sum)
				}
			},
			toStr(val) {
				return toStr(val)
			},
		}
	}
</script>

<style scoped>

</style>
